module.exports = __webpack_public_path__ + "static/go-the-fuck-to-sleep-4716032350bb1e18c7e2710ca30828e7.jpg";